// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Hn-z","selected":"In-z"};